import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Link, Typography, Avatar } from '@mui/material';
import _ from 'lodash';

import useAuth from '../../../hooks/useAuth';
import { USER_ROLES } from '../../../_mock/role';
import MyAvatar from '../../../components/MyAvatar';
import { adminApi } from '../../../utils/axios';
import { USERS } from '../../../utils/apiUrl';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarAccount({ isCollapse }) {
  const { user } = useAuth();
  const [loggedInUserData, setLoggedInUserData] = useState(null);

  useEffect(() => {
    if (user) {
      const decodeuserData = jwtDecode(user.access);
      getUserData(decodeuserData.user_id);
    }
  }, [user]);

  // Getting User Module access
  function getUserData(id) {
    adminApi
      .get(`${USERS}${id}/`)
      .then(({ data }) => {
        // console.log('logged in user data', data);
        setLoggedInUserData(data);
      })
      .catch((error) => console.log('user data error', error));
  }

  return (
    <Link underline="none" color="inherit">
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent',
          }),
        }}
      >
        <MyAvatar />

        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
          }}
        >
          <Typography variant="subtitle2" noWrap>
            {loggedInUserData?.first_name} {loggedInUserData?.last_name}
          </Typography>
        </Box>
      </RootStyle>
    </Link>
  );
}
